import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { VerticalDoubleCheckIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const SaveAllIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>((props, ref) => {
  const { t } = useTranslation();
  const {
    tooltipTitle = t('users.save_all_tooltip', 'Save All [Ctrl+S]'),
    ...buttonProps
  } = props;

  return (
    <IconButton
      ref={ref}
      {...buttonProps}
      tooltipTitle={tooltipTitle}
    >
      <VerticalDoubleCheckIcon color="inherit" />
    </IconButton>
  );
});

SaveAllIconButton.displayName = 'SaveAllIconButton';

export default SaveAllIconButton;
